export function normalizeCatalog(payload) {
  const datasets = payload?.datasets || [];
  const questionTypes = payload?.question_types || [];
  return {
    datasets: datasets.map((item) => ({
      id: item.id,
      label: item.label,
      description: item.description,
      metrics: item.metrics || [],
      dimensions: item.dimensions || [],
    })),
    questionTypes: questionTypes.map((item) => ({
      id: item.id,
      label: item.label,
      description: item.description,
      autoViz: item.auto_viz,
    })),
  };
}

export default normalizeCatalog;
